import React, { useContext } from 'react';
import { UserData } from "@/components/Context";
import { useState } from 'react';
import Text from '@/components/LanguageResolver';

export default function UserBalance() {

    const [ isHovered, setIsHovered ] = useState(false);
    const { user } = useContext(UserData);

    return (
        <>
            <p style={{padding: '0.3rem 0 0.3rem 0',cursor:'pointer'}} onClick={() => {
                if (user.isLoaded) {
                    navigator.clipboard.writeText(user.tokenBalance);
                    window.showMessage("message.copiedtoclipboard", 'success');
                  }
                  else {
                    window.showMessage("message.pleasewait", 'error');
                  }
            }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}><Text val="user.balance"/>: {user.isLoaded ? ((isHovered ? Math.max(user.tokenBalance, 0).toFixed(2) : Math.max(user.tokenBalance, 0))) + "🪙" : <Text val="message.loading"/>}</p>
        </>
    );
}